export default __webpack_public_path__ + "static/media/honey3.ee4a60a4.webp";